(function () {
  var LOW_PRIORITY_SELECTORS = [
    'img[src*="judgeme"]',
    'img[src*="judge.me"]',
    'img[src*="cdnwidget.judge.me"]',
    'img[src*="judgeme.imgix.net"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtu.be"]'
  ];

  var GALLERY_SELECTOR = '.productView-image img, .productView-img-container img, .productView-media img, .product-single__media img';

  function setFetchPriority(element, priority) {
    try {
      element.fetchPriority = priority;
    } catch (error) {}
    element.setAttribute('fetchpriority', priority);
  }

  function markPriorityImage(image) {
    if (!image) return;
    image.loading = 'eager';
    image.decoding = 'sync';
    setFetchPriority(image, 'high');
    image.setAttribute('data-yshomy-priority-image', 'true');
  }

  function markLazyImage(image) {
    if (!image || image.hasAttribute('data-yshomy-priority-image')) return;
    image.loading = 'lazy';
    image.decoding = 'async';
    setFetchPriority(image, 'low');
  }

  function pathOf(value) {
    if (!value) return '';
    try {
      return new URL(value, window.location.href).pathname;
    } catch (error) {
      return '';
    }
  }

  function imagePath(image) {
    return pathOf(image.getAttribute('src') || image.getAttribute('data-src') || '');
  }

  /*
   * layout/theme.liquid 已经在 <head> 里 preload 了真正的 LCP 图（跟随当前变体）。
   * 这里直接读那个 preload 作为唯一真相，避免 JS 和 preload 指向不同图片。
   */
  function preloadedImagePath() {
    var link = document.querySelector('link[rel="preload"][as="image"]');
    return link ? pathOf(link.getAttribute('href')) : '';
  }

  function isPersonalizedGiftPdp() {
    return document.body && document.body.className.includes('yshomy-personalized-gift-pdp');
  }

  /*
   * 产品首图。
   * 注意：图库的 data-index 从 1 开始，不是 0；
   * 并且开屏显示的是当前变体绑定的图，不一定是图库第一张。
   * 因此以 head 里的 preload 为准，同一张图的所有副本（含 Slick 克隆）全部标高优先级。
   */
  function prioritizeProductHeroImage() {
    if (!document.body || !document.body.className.includes('template-product')) return;

    var gallery = Array.prototype.slice.call(document.querySelectorAll(GALLERY_SELECTOR));
    if (!gallery.length) return;

    var targetPath = preloadedImagePath();
    var matched = targetPath
      ? gallery.filter(function (image) { return imagePath(image) === targetPath; })
      : [];

    if (!matched.length) {
      var fallback = gallery.filter(function (image) {
        return image.getAttribute('data-index') === '1';
      })[0] || gallery[0];
      if (fallback) matched = [fallback];
    }

    matched.forEach(markPriorityImage);
    gallery.forEach(markLazyImage);
  }

  function prioritizeHomepageHeroMedia() {
    if (!document.body || !document.body.className.includes('template-index')) return;

    var heroCandidates = Array.prototype.slice.call(document.querySelectorAll([
      '.sections-image-banner-block img',
      '.slideshow .item:first-child img'
    ].join(',')));

    var hero = heroCandidates[0];
    if (hero) {
      var heroPath = imagePath(hero);
      heroCandidates.forEach(function (image) {
        if (image === hero || (heroPath && imagePath(image) === heroPath)) {
          markPriorityImage(image);
        }
      });
    }

    document.querySelectorAll('.header__heading-logo, .header-mobile img[class*="logo"]').forEach(markPriorityImage);
    document.querySelectorAll('.slideshow .item:not(:first-child) img').forEach(markLazyImage);
  }

  /*
   * 只降低明确的非关键第三方媒体优先级。
   *
   * 旧版本还有一个 lowerBelowFoldImages()，会遍历全部 <img> 并根据
   * getBoundingClientRect() 把“不在首屏”的图降为 fetchpriority=low。
   * 它在 DOMContentLoaded 时机运行，此时很多图尚未完成布局，高度为 0，
   * 会被误判为首屏外而降级——包括实际被绘制的 LCP 图。已删除。
   */
  function lowerNonCriticalMedia() {
    LOW_PRIORITY_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.hasAttribute('data-yshomy-priority-image')) return;
        var rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 1.2) return;
        element.loading = 'lazy';
        if (element.tagName === 'IMG') {
          element.decoding = 'async';
          setFetchPriority(element, 'low');
        }
      });
    });

    document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]').forEach(function (iframe) {
      iframe.loading = 'lazy';
    });
  }

  function enrichMissingAltText() {
    document.querySelectorAll('.product-item img:not([alt]), .product-item img[alt=""]').forEach(function (image) {
      var card = image.closest('.product-item');
      var title = card && card.querySelector('.card-title, .card__heading a');
      if (!title) return;
      image.alt = title.textContent.trim();
    });

    document.querySelectorAll('.collection-item img:not([alt]), .collection-item img[alt=""]').forEach(function (image) {
      var card = image.closest('.collection-item');
      var title = card && card.querySelector('a, .title, .collection-title');
      if (!title) return;
      image.alt = title.textContent.trim();
    });
  }

  function addProductTrustRow() {
    if (!document.body || !document.body.className.includes('template-product')) return;
    if (document.body.className.includes('template-product-default')) return;
    if (isPersonalizedGiftPdp()) return;
    if (document.querySelector('.yshomy-trust-row')) return;

    var target = document.querySelector('.productView-price, .productView-price .price, .price.price--large');
    var form = document.querySelector('.productView-form, .product-form');
    if (!target && !form) return;

    var row = document.createElement('div');
    row.className = 'yshomy-trust-row';
    row.setAttribute('aria-label', 'YSHomy order benefits');
    row.innerHTML = '<span>Gift-ready packaging</span><span>Handmade to order</span><span>Fast US-friendly delivery options</span>';

    if (target && target.parentNode) {
      target.parentNode.insertBefore(row, target.nextSibling);
    } else if (form && form.parentNode) {
      form.parentNode.insertBefore(row, form);
    }
  }

  function addProductSeoPaths() {
    if (!document.body || !document.body.className.includes('template-product')) return;
    if (document.body.className.includes('template-product-default')) return;
    if (isPersonalizedGiftPdp()) return;
    if (document.querySelector('.yshomy-product-paths')) return;

    var form = document.querySelector('.productView-form, .product-form, form[action*="/cart/add"]');
    if (!form || !form.parentNode) return;

    var title = (document.querySelector('.productView-title, h1') || {}).textContent || document.title || '';
    var titleText = title.toLowerCase();
    var links = [
      ['All crochet bouquets', '/collections/crochet-bouquet'],
      ['Custom bouquet', '/products/yshomy-customized-crochet-flowers-bouquet-items']
    ];

    if (titleText.indexOf('rose') !== -1) links.push(['Rose bouquets', '/collections/crochet-rose-bouquets']);
    if (titleText.indexOf('tulip') !== -1) links.push(['Tulip bouquets', '/collections/crochet-tulip-bouquets']);
    if (titleText.indexOf('sunflower') !== -1) links.push(['Sunflower bouquets', '/collections/crochet-sunflower-bouquets']);
    if (titleText.indexOf('pink') !== -1) links.push(['Pink bouquets', '/collections/pink-crochet-bouquets']);
    if (titleText.indexOf('blue') !== -1) links.push(['Blue bouquets', '/collections/blue-crochet-bouquets']);
    if (titleText.indexOf('purple') !== -1) links.push(['Purple bouquets', '/collections/purple-crochet-bouquets']);
    if (titleText.indexOf('graduation') !== -1) links.push(['Graduation gifts', '/collections/graduation-crochet-bouquets']);

    links.push(['Mother’s Day gifts', '/collections/mother-s-day-crochet-bouquets']);
    links.push(['Birthday gifts', '/collections/birthday-crochet-bouquets']);

    var unique = [];
    var seen = {};
    links.forEach(function (link) {
      if (seen[link[1]]) return;
      seen[link[1]] = true;
      unique.push(link);
    });

    var box = document.createElement('nav');
    box.className = 'yshomy-product-paths';
    box.setAttribute('aria-label', 'Related YSHomy gift collections');
    box.innerHTML = '<p>Shop by gift idea</p><div>' + unique.slice(0, 6).map(function (link) {
      return '<a href="' + link[1] + '">' + link[0] + '</a>';
    }).join('') + '</div>';

    form.parentNode.insertBefore(box, form.nextSibling);
  }

  function hidePersonalizedDescriptionAttention() {
    if (!isPersonalizedGiftPdp()) return;

    document.querySelectorAll('[product-description-tab]').forEach(function (tab) {
      var firstParagraph = tab.querySelector('p');
      if (!firstParagraph) return;

      var text = firstParagraph.textContent.trim().toLowerCase();
      if (text.indexOf('attention') === -1 && text.indexOf('please note') !== 0) return;

      firstParagraph.hidden = true;
      firstParagraph.classList.add('yshomy-hidden-attention');
    });
  }

  function dedupeProductPurchaseControls() {
    if (!document.body || !document.body.className.includes('template-product')) return;

    var purchaseArea = document.querySelector('.productView, .productView-info, .productView-details, main');
    if (!purchaseArea) return;

    var ignored = '.productView-stickyCart, .halo-sticky-toolbar-mobile, .shopify-payment-button, .quickCartWrap, .cart, .drawer';
    var addButtons = Array.prototype.slice.call(purchaseArea.querySelectorAll('.product-form__submit, [data-btn-addtocart], button[name="add"]'))
      .filter(function (button) {
        return !button.closest(ignored);
      });

    var firstButton = addButtons.find(function (button) {
      return button.offsetParent !== null;
    });

    addButtons.forEach(function (button) {
      if (button === firstButton) return;
      var wrapper = button.closest('form[action*="/cart/add"], .productView-form, .product-form, .product-form__buttons') || button;
      wrapper.setAttribute('data-yshomy-duplicate-purchase', 'true');
    });

    var quantityBlocks = Array.prototype.slice.call(purchaseArea.querySelectorAll('.productView-quantity, .product-form__quantity, quantity-input, .quantity'))
      .filter(function (block) {
        return !block.closest(ignored);
      });

    var firstQuantity = quantityBlocks.find(function (block) {
      return block.offsetParent !== null;
    });

    quantityBlocks.forEach(function (block) {
      if (block === firstQuantity || block.contains(firstQuantity)) return;
      block.setAttribute('data-yshomy-duplicate-purchase', 'true');
    });
  }

  function updateCustomOrderButtons() {
    if (!document.body || !document.body.className.includes('template-product')) return;

    var text = [
      document.title,
      window.location.pathname,
      document.body.getAttribute('class') || ''
    ].join(' ').toLowerCase();

    var isCustom = text.indexOf('custom') !== -1 ||
      text.indexOf('personalized') !== -1 ||
      text.indexOf('photo') !== -1 ||
      text.indexOf('customize') !== -1;

    if (!isCustom) return;

    document.querySelectorAll('.product-form__submit, [data-btn-addtocart], button[name="add"]').forEach(function (button) {
      var label = button.querySelector('[data-add-to-cart-text], .text, span') || button;
      var current = label.textContent.trim().toLowerCase();
      if (current.indexOf('sold') !== -1 || current.indexOf('unavailable') !== -1) return;
      label.textContent = 'Start Custom Order';
      button.setAttribute('aria-label', 'Start custom order');
    });
  }

  function gateMobileStickyAddToCart() {
    if (!document.body || !document.body.className.includes('template-product')) return;

    var primaryButton = document.querySelector('.product-form__submit, [data-btn-addtocart], button[name="add"]');
    if (!primaryButton) return;

    function refresh() {
      if (window.innerWidth > 767) {
        document.body.classList.add('yshomy-show-sticky-atc');
        return;
      }

      var rect = primaryButton.getBoundingClientRect();
      if (rect.bottom < 0) {
        document.body.classList.add('yshomy-show-sticky-atc');
      } else {
        document.body.classList.remove('yshomy-show-sticky-atc');
      }
    }

    refresh();
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
  }

  function polishHeaderNavigation() {
    document.querySelectorAll('.header-navigation a, .site-nav a, .menu-lv-1__action').forEach(function (link) {
      var label = link.textContent.trim().toLowerCase();
      if (label.indexOf('custom') !== -1) {
        link.classList.add('yshomy-nav-customize');
      }
      if (label === 'wholesale') {
        var item = link.closest('li');
        if (item) item.setAttribute('data-yshomy-footer-only', 'true');
      }
    });
  }

  function addFooterWholesaleLink() {
    var footer = document.querySelector('.wrapper-footer');
    if (!footer || footer.querySelector('a[href*="wholesale"], .yshomy-footer-wholesale')) return;

    var link = document.createElement('div');
    link.className = 'yshomy-footer-wholesale';
    link.innerHTML = '<a href="/pages/wholesale">Wholesale</a>';
    footer.appendChild(link);
  }

  /*
   * Judge.me 品牌写法统一。
   * 旧版本在 0 / 500 / 1500ms 跑三次，且会改写 <style> 与 <script> 的 textContent——
   * 改写 <style> 会强制样式重算，改写已执行的 <script> 则毫无效果。
   * 改为只处理设置对象与样式，并只在 DOMContentLoaded 与 load 各跑一次。
   */
  function normalizeJudgeMeBranding() {
    var replaceBrand = function (value) {
      return typeof value === 'string' ? value.replace(/\bY[Ss]homy\b/g, 'YSHomy') : value;
    };

    if (window.jdgmSettings) {
      window.jdgmSettings.reply_name = replaceBrand(window.jdgmSettings.reply_name);
      window.jdgmSettings.reply_name_text = replaceBrand(window.jdgmSettings.reply_name_text);
    }

    document.querySelectorAll('style.jdgm-settings-style').forEach(function (style) {
      var next = replaceBrand(style.textContent);
      if (next !== style.textContent) style.textContent = next;
    });
  }

  function init() {
    prioritizeHomepageHeroMedia();
    prioritizeProductHeroImage();
    lowerNonCriticalMedia();
    enrichMissingAltText();
    addProductTrustRow();
    addProductSeoPaths();
    hidePersonalizedDescriptionAttention();
    dedupeProductPurchaseControls();
    updateCustomOrderButtons();
    gateMobileStickyAddToCart();
    polishHeaderNavigation();
    addFooterWholesaleLink();
    normalizeJudgeMeBranding();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    lowerNonCriticalMedia();
    enrichMissingAltText();
    normalizeJudgeMeBranding();
  }, { once: true });
})();
